<!--
 * @FileDescription: 
 * @Author: jianguo Wang
 * @Date: 2023-12-14 15:29:31
 * @LastEditors: jianguo Wang
 * @LastEditTime: 2025-01-10 14:18:02
-->
<template>
  <div class="page-contain">
    <div class="step-contain">
      <div class="step-box">
        <img src="@/assets/img/iconUser@3x.png" alt="" class="step-icon" />
        <div class="step-title">{{ $t('components.secondPart.561361-0') }}</div>
        <div class="step-tip">{{ $t('components.secondPart.561361-1') }}</div>
      </div>
      <div class="step-box">
        <img src="@/assets/img/iconKYC@3x.png" alt="" class="step-icon" />
        <div class="step-title">{{ $t('components.secondPart.561361-2') }}</div>
        <div class="step-tip">{{ $t('components.secondPart.561361-3') }}</div>
      </div>
      <div class="step-box">
        <img src="@/assets/img/iconSafetouse@3x.png" alt="" class="step-icon" />
        <div class="step-title">{{ $t('components.secondPart.561361-4') }}</div>
        <div class="step-tip">{{ $t('components.secondPart.561361-5') }}</div>
      </div>
    </div>

    <div class="content-section">
    <!-- pc -->
    <div class="pc-contain">
      <!-- 第一块：左边图片，右边文字 -->
      <div class="contain contain-img-left">
        <img class="content-img" src="@/assets/img/Pic1@3x.png" alt="" />
        <div class="tip-contain">
          <div class="tip1">{{ $t('components.secondPart.561361-6') }} {{ $t('components.secondPart.561361-7') }}</div>
          <div class="tip2">{{ $t('components.secondPart.561361-8') }}</div>
        </div>
      </div>
      <!-- 第二块：左边文字，右边图片 -->
      <div class="contain">
        <div class="tip-contain">
          <div class="tip1">{{ $t('components.secondPart.561361-9') }}</div>
          <div class="tip2">{{ $t('components.secondPart.561361-10') }}</div>
        </div>
        <img class="content-img" src="@/assets/img/Pic2@3x.png" alt="" />
      </div>
      <!-- 第三块：左边图片，右边文字 -->
      <div class="contain contain-img-left">
        <img class="content-img" src="@/assets/img/Pic3@3x.png" alt="" />
        <div class="tip-contain">
          <div class="tip1">{{ $t('components.secondPart.561361-11') }}</div>
          <div class="tip2">
            {{ $t('components.secondPart.561361-12') }}
          </div>
        </div>
      </div>
      <!-- 第四块：左边文字，右边图片 -->
      <div class="contain">
        <div class="tip-contain">
          <div class="tip1">{{ $t('components.secondPart.561361-13') }}</div>
          <div class="tip2">
            {{ $t('components.secondPart.561361-14') }}
            {{ $t('components.secondPart.561361-15') }}
          </div>
        </div>
        <img class="content-img" src="@/assets/img/Pic4@3x.png" alt="" />
      </div>
    </div>

    <!-- 移动端 -->
    <div class="phone-contain">
      <!-- 第一块：图片上，文字下 -->
      <div class="contain phone-contain-img-left">
        <img class="content-img" src="@/assets/img/Pic1@3x.png" alt="" />
        <div class="tip-contain">
          <div class="tip1">{{ $t('components.secondPart.561361-6') }} {{ $t('components.secondPart.561361-7') }}</div>
          <div class="tip2">{{ $t('components.secondPart.561361-8') }}</div>
        </div>
      </div>
      <div class="contain">
        <div class="tip-contain">
          <div class="tip1">{{ $t('components.secondPart.561361-9') }}</div>
          <div class="tip2">{{ $t('components.secondPart.561361-10') }}</div>
        </div>
        <img class="content-img" src="@/assets/img/Pic2@3x.png" alt="" />
      </div>
      <!-- 第三块：图片上，文字下 -->
      <div class="contain phone-contain-img-left">
        <img class="content-img" src="@/assets/img/Pic3@3x.png" alt="" />
        <div class="tip-contain">
          <div class="tip1">{{ $t('components.secondPart.561361-11') }}</div>
          <div class="tip2">
            {{ $t('components.secondPart.561361-12') }}
          </div>
        </div>
      </div>
      <div class="contain">
        <div class="tip-contain">
          <div class="tip1">{{ $t('components.secondPart.561361-13') }}</div>
          <div class="tip2">
            {{ $t('components.secondPart.561361-14') }}
          </div>
        </div>
        <img class="content-img" src="@/assets/img/Pic4@3x.png" alt="" />
      </div>
    </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "secondPart",
  props: {
    msg: String,
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style src="./secondPartCss/max.css" scoped></style>
<style src="./secondPartCss/middle.css" scoped></style>
<style src="./secondPartCss/flat.css" scoped></style>
<style src="./secondPartCss/min.css" scoped></style>
<style scoped></style>
